module.exports = __webpack_public_path__ + "static/img/静止.c96904e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/车辆/挖掘机/静止.png
// module id = 05AN
// module chunks = 76